import React from "react";
import {
  Paper,
  Grid,
  Typography,
  Divider,
  Button,
  IconButton,
  makeStyles,
  Box,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { ColorRow } from "./ColorRow";
import { labelsColors } from "../../../core/redux/dataMap/label";

export default function LabelsCard({
  onClose,
  setCreate,
  labels,
  snippetLabels,
  onAddLabel,
  onRemoveLabel,
  onEditLabel,
}) {
  const classes = useStyles();
  const isLabelSelected = (label) => {
    if (!snippetLabels) return false;
    return snippetLabels.some((snippetLabel) => snippetLabel.id === label.id);
  };

  return (
    <Paper>
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid item md={10} xs={9}>
          <Typography className={classes.title}>Labels</Typography>
        </Grid>
        <Grid item md={2}>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
      <Divider />
      <Box p={1}>
        {labels &&
          !!labels.length &&
          labels.map((label) => (
            <ColorRow
              color={labelsColors[label.color]}
              name={label.name}
              key={label.id}
              onAddLabel={() => onAddLabel(label)}
              onRemoveLabel={() => onRemoveLabel(label)}
              onEditLabel={() => onEditLabel({ status: true, label })}
              isLabelSelected={isLabelSelected(label)}
            />
          ))}
      </Box>
      <Divider />
      <Box p={1}>
        <Button fullWidth onClick={setCreate}>
          <Typography className={classes.buttonText}>
            Create new label
          </Typography>
        </Button>
      </Box>
    </Paper>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "100px 0",
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "13px",
    lineHeight: "14px",
    color: "#9A9A9A",
    textAlign: "center",
    width: "100%",
  },
  buttonText: {
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "13px",
    lineHeight: "14px",
    color: "#9A9A9A",
    textAlign: "center",
    width: "100%",
    textTransform: "none",
  },
}));
